import React from "react";
import './HeroSection.css'
import HeroSectionFunc from "./HeroSectionFunc";





export default function HeroSection({item}){


    return(
        <HeroSectionFunc list={item.items}/>
    )
}